<div>
	<canvas baseChart
		[datasets]="radarChartData"
		[labels]="radarChartLabels"
		[chartType]="radarChartType"
	></canvas>
</div>
